import FilterRow from 'components/common/FilterRow';
import CardinalDashboard from 'components/dashboard/cardinal/CardinalDashboard';
import {
	Background,
	BodyInnerWrapper,
	BodyWrapper,
} from 'styles/styled-components/section';

const Dashboard = () => {
	return (
		<Background>
			<FilterRow />
			<BodyWrapper options={{ scrollbars: { autoHide: 'move', autoHideDelay: 250 } }}>
				<BodyInnerWrapper>
					<CardinalDashboard />
				</BodyInnerWrapper>
			</BodyWrapper>
		</Background>
	);
};

export default Dashboard;
